import { render, staticRenderFns } from "./management-library-datasource-form.vue?vue&type=template&id=19afe2d2"
import script from "./management-library-datasource-form.vue?vue&type=script&lang=js"
export * from "./management-library-datasource-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports